import React from "react";
import "./TrialBanner.css";

export default function TrialBanner({ onClose }) {
  return (
    <div className="popup-overlay">
      <div className="popup-banner">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        <img
          src="./Banner.png"
          alt="Valsco Tech Banner"
          className="banner-img"
        />
      </div>
    </div>
  );
}
